/**
 * WOOF Reveal
 * Tiny shared scroll-reveal: elements marked with [data-woof-reveal] get the
 * `woof-revealed` class when they enter the viewport (once). Optional
 * per-element stagger via data-woof-reveal-delay="120" (ms). Sections define
 * the actual transition CSS; with reduced motion everything reveals instantly.
 */
function init() {
  const elements = document.querySelectorAll('[data-woof-reveal]:not(.woof-revealed)');
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    elements.forEach((el) => el.classList.add('woof-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = Number(el.dataset.woofRevealDelay || 0);
        el.style.transitionDelay = delay ? `${delay}ms` : '';
        el.classList.add('woof-revealed');
        observer.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  elements.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
// Re-scan after theme editor section reloads
document.addEventListener('shopify:section:load', init);
